export default __webpack_public_path__ + "static/media/attachment.595ada9e.svg";